/**
 * SICH — Header sticky behavior (Opción B)
 */
(function() {
  'use strict';

  const SCROLL_THRESHOLD = 5;
  const TOP_THRESHOLD = 50;

  let lastScrollY = window.scrollY;
  let lastSignificantDirection = 'up';
  let ticking = false;
  const body = document.body;

  function setHeaderState() {
    const currentScrollY = window.scrollY;
    const scrollDelta = currentScrollY - lastScrollY;

    body.classList.remove('sich-header-top', 'sich-header-visible', 'sich-header-hidden');

    if (currentScrollY < TOP_THRESHOLD) {
      body.classList.add('sich-header-top');
    } else if (scrollDelta > SCROLL_THRESHOLD) {
      body.classList.add('sich-header-hidden');
      lastSignificantDirection = 'down';
    } else if (scrollDelta < -SCROLL_THRESHOLD) {
      body.classList.add('sich-header-visible');
      lastSignificantDirection = 'up';
    } else {
      if (lastSignificantDirection === 'down') {
        body.classList.add('sich-header-hidden');
      } else {
        body.classList.add('sich-header-visible');
      }
    }

    if (Math.abs(scrollDelta) > SCROLL_THRESHOLD) {
      lastScrollY = currentScrollY;
    }

    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      window.requestAnimationFrame(setHeaderState);
      ticking = true;
    }
  }

  document.addEventListener('DOMContentLoaded', function() {
    if (window.scrollY < TOP_THRESHOLD) {
      body.classList.add('sich-header-top');
    } else {
      body.classList.add('sich-header-visible');
    }
  });

  window.addEventListener('scroll', onScroll, { passive: true });

  window.addEventListener('pageshow', function() {
    lastScrollY = window.scrollY;
    setHeaderState();
  });
})();